import React from "react";
import styled from "styled-components";

interface LabelProps {
  isError?: boolean;
  isTextCentered?: boolean;
  isParagraph?: boolean;
  children: any;
}

const StyledLabel = styled.label<LabelProps>`
  display: block;
  color: ${(props) =>
    props.isError
      ? props.theme.colours.global.alarm
      : props.theme.colours.textInput.title.color};
  font-size: 14px;
  margin-bottom: 4px;
  ${(props) => props.isTextCentered && `text-align: center;`}
`;
StyledLabel.displayName = "StyledLabel";

const StyledParagraph = styled.p<LabelProps>`
  display: block;
  color: ${(props) =>
    props.isError
      ? props.theme.colours.global.alarm
      : props.theme.colours.textInput.title.color} !important;
  font-size: 14px !impotant;
  margin-bottom: 4px;
  ${(props) => props.isTextCentered && `text-align: center;`}
`;
StyledParagraph.displayName = "StyledParagraph";

const Label = ({
  isError = false,
  isTextCentered = false,
  isParagraph = false,
  children,
}: LabelProps) => {
  if (isParagraph) {
    return (
      <StyledParagraph isError={isError} isTextCentered={isTextCentered}>
        {children}
      </StyledParagraph>
    );
  }

  return (
    <StyledLabel isError={isError} isTextCentered={isTextCentered}>
      {children}
    </StyledLabel>
  );
};

export default Label;
